import React from 'react'
import { NotificationBadge } from '../components'

export const renderNotificationBadge = (data: object) => {
  const value = Number(data)

  return value > 0 ? <NotificationBadge value={value} /> : null
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/render-utils.tsx